import {CLTagProps} from 'common/src/components/CLTagsList/CLTagsList';
import {DateTime} from 'luxon';

export enum FeatureFlagKey {
  DisableDigitalOutOfHomeImageCampaigns = 'disableDigitalOutOfHomeImageCampaigns',
  DisableDisplayFCCampaigns = 'disableDisplayFCCampaigns',
  DisableFacebookFCCampaigns = 'disableFacebookFCCampaigns',
  DisableInBannerVideoFCCampaigns = 'disableInBannerVideoFCCampaigns',
  DisableInteractiveVideoFCCampaigns = 'disableInteractiveVideoFCCampaigns',
  DisableNativeFCCampaigns = 'disableNativeFCCampaigns',
  DisableThirdPartyAdTrackingCampaigns = 'disableThirdPartyAdTrackingCampaigns',
  DisableTikTokFCCampaigns = 'disableTikTokFCCampaigns',
  DisableYoutubeFCCampaigns = 'disableYoutubeFCCampaigns',
  EnableLinkedinCampaign = 'enableLinkedinCampaign',
  DisableVideoFCCampaigns = 'disableVideoFCCampaigns',
  DisableAudioAdsFCCampaigns = 'disableAudioAdsFCCampaigns',
  EnableIdentityTimeline = 'enableIdentityTimeline',
  EnableJavascriptTrackers = 'EnableJavascriptTrackers',
  EnableEditingAdservingPartners = 'CanEditAdservingPartners',
  EnableMagnifier = 'enableMagnifier',
  EnableDynamicSourceEdit = 'enableDynamicSourceEdit',
  EnableMultipleFeedsDeletion = 'enableMultipleFeedsDeletion',
  EnableDuplicatingFacebookCampaigns = 'enableDuplicatingFacebookCampaigns',
  OpenNavbarOnHover = 'openNavbarOnHover',

  // COPILOT
  EnableCopilotDebugMode = 'enableCopilotDebugMode',
  EnableCopilotChatDownload = 'enableCopilotChatDownload',
  EnableCopilotKnowledgeMonitoring = 'enableCopilotKnowledgeMonitoring',
  EnableCopilotDraftReferences = 'enableCopilotDraftReferences',
  EnableCopilotCampaignAnalyticsMonitoring = 'enableCopilotCampaignAnalyticsMonitoring',
  EnableCopilotLaunchButton = 'enableCopilotLaunchButton',
  EnableCopilotResourceKnowledge = 'enableCopilotResourceKnowledge',
  EnableRouterSlimSchema = 'enableRouterSlimSchema',
  EnableCopilotPlan = 'enableCopilotPlan',

  // Enabling copilot agents
  EnableCopilotAgents = 'enableCopilotAgents',
  EnableCopilotCampaignsManagerAgent = 'enableCopilotCampaignsManagerAgent',
  EnableCopilotCampaignSetupAgent = 'enableCopilotCampaignSetupAgent',
  EnableCopilotExcelToCampaignAgent = 'enableCopilotExcelToCampaignAgent',
  EnableCopilotBriefAndStrategyAgents = 'enableCopilotBriefAndStrategyAgents',
  EnableCopilotCampaignAnalyticsAgent = 'enableCopilotCampaignAnalyticsAgent',
  EnableCopilotAdBuilderAgent = 'enableCopilotAdBuilderAgent',
  EnableCopilotBrandGuidelinesAgent = 'enableCopilotBrandGuidelinesAgent',
  EnableBillingForManagement = 'enableBillingForManagement',
  EnableCopilotAccountAnalyticsAgent = 'enableCopilotAccountAnalyticsAgent',
  EnableCopilotSocialCampaignSetupAgent = 'enableCopilotSocialCampaignSetupAgent',
  EnableCopilotAiContentProjectAgent = 'enableCopilotAiContentProjectAgent',
  EnableCopilotInSupportOnlyMode = 'enableCopilotInSupportOnlyMode',

  // OTHER
  EnableFlightAcademy = 'enableFlightAcademy',
  HideAgencyCreation = 'hideAgencyCreation',
  EnableAdvertiserDisconnectionNewFlow = 'enableAdvertiserDisconnectionNewFlow',
  AllAdVarationsCheckbox = 'AllAdVarationsCheckbox',
  EnablePausingOfExternalAds = 'EnablePausingOfExternalAds',
  SetMaxAttributionLookbackWindowTo90Days = 'setMaxAttributionLookbackWindowTo90Days',
  EnablePlacementsDateParams = 'enablePlacementsDateParams',
  EnableInitialContentCreation = 'enableInitialContentCreation',
  AllowEditingNotificationSettings = 'allowEditingNotificationSettings',
  EnableConceptFallbackOutputs = 'enableConceptFallbackOutputs',
  EnableFeedDescriptionsInConceptPlan = 'enableFeedDescriptionsInConceptPlan',
  EnableCreativeFieldsInConceptPlan = 'enableCreativeFieldsInConceptPlan',
  EnableCampaignApproval = 'enableCampaignApproval',
  EnableUserLastAccessColumn = 'enableUserLastAccessColumn',
  EnableDspsPublishersAgencyLevel = 'enableDspsPublishersAgencyLevel',
  EnableAssetsManagerMetadataColumn = 'enableAssetsManagerMetadataColumn',
  EnableDoohScreens = 'enableDoohScreens',
  SuppressCardsSubMenus = 'suppressCardsSubMenus',
  EnableConceptPlan = 'enableConceptPlan',
  EnableCampaignTrackers = 'enableCampaignTrackers',
  EnableYouTubePreview = 'enableYouTubePreview',
  EnableAdVariationAnalysis = 'enableAdVariationAnalysis',

  EnableMediaPerformanceDataSourceCreation = 'enableMediaPerformanceDataSourceCreation',
  EnableTestingTokyoOlympics = 'enableTestingTokyoOlympics',
  EnableProductCategoriesSelectionInDPA = 'EnableProductCategoriesSelectionInDPA',
  EnableOlympicMedals = 'enableOlympicMedals',
  EnableOlympicEvents = 'enableOlympicEvents',
  EnableYoutubeDV360Campaign = 'enableYoutubeDV360Campaign',
  EnableBackgroundRemovalInFeeds = 'EnableBackgroundRemovalInFeeds',
  EnableReplaceImageInFeeds = 'enableReplaceImageInFeeds',
  EnableDuplicateNodesValidation = 'enableDuplicateNodesValidation',
  EnableGuestTokenAuthorization = 'enableGuestTokenAuthorization',
  EnableAIMiniBrief = 'enableAIMiniBrief',
  EnableTaxonomyType = 'enableTaxonomyType',
  EnableCampaignMapVersionAnalyticsAlignment = 'enableCampaignMapVersionAnalyticsAlignment',
  EnableTrackingVendors = 'enableTrackingVendors',
  EnableTrackingVendorWritePermissions = 'canEditTrackingVendors',
  EnableAutomaticPublishing = 'enableAutomaticPublishing',
  EnableTextToSpeech = 'enableText2Speech',
  EnableSpeechToText = 'enableSpeech2Text',
  EnableImportingCM360Placements = 'enableImportingCM360Placements',
  EnableMediaValidations = 'enableMediaValidations',
  EnableAudienceInsights = 'enableAudienceInsights',
  EnableExtendedJobStatsCounters = 'enableExtendedJobStatsCounters',
  EnableLogLevelDataSharing = 'enableLogLevelDataSharing',
  EnablePingForAttribution = 'enablePingForAttribution',
  EnableContentMatrix = 'enableContentMatrix',
  EnableContentFeed = 'enableContentMatrix',
  EnableViewedImpressions = 'enableViewedImpressions',
  EnableExternalConversionOptimization = 'enableExternalConversionOptimization',
  EnableProductsByDSPStrategy = 'enableProductsByDSPStrategy',
  EnableDragAndDropFont = 'enableDragAndDropFont',
  ShowStrategySelectionInContentCard = 'showStrategySelectionInContentCard',
  EnableTTDEditing = 'enableTTDEditing',
  EnableAmazonIntegration = 'enableAmazonIntegration',
  EnableItemPerCategory = 'enableItemPerCategory',
  EnableCancelPublishButton = 'enableCancelPublishButton',
  EnableBilling = 'enableBilling',
  EnableCampaignVersionDimensions = 'enableCampaignVersionDimensions',
  EnableNewImageEditor = 'enableNewImageEditor',
  EnableNewTargetPlatforms = 'enableNewTargetPlatforms',
  EnableNewTargetPlatformsInCampaigns = 'enableNewTargetPlatformsInCampaigns',
  EnableBrandGuidelines = 'enableBrandGuidelines',
  EnableDataOutputsAgencyFiltering = 'enableDataOutputsAgencyFiltering',
  EnableForceUseFontService = 'forceUseFontService',
  EnableViewedItemsStrategy = 'enableViewedItemsStrategy',
  EnableNewRetargetingAlgo = 'newRetargetingAlgo',
  EnableAdvertiserSettings = 'enableAdvertiserSettings',
  EnableCampaignCollaborationBadges = 'enableCampaignCollaborationBadges',
  EnableProfileCustomParameters = 'enableProfileCustomParameters',
  EnableLanguageCreativeTableColumn = 'enableLanguageCreativeTableColumn',
  EnableOptimizationBulkExport = 'enableOptimizationBulkExport',
  EnableTtdCvrTaxonomizedColumnNames = 'enableTtdCvrTaxonomizedColumnNames',
  EnableContentMacrosForIdentityFields = 'enableContentMacrosForIdentityFields',
  EnableDataOutputsDimensionNaming = 'enableDataOutputsDimensionNaming',
  EnableDataSourcesAdditionalConfigurations = 'enableDataSourcesAdditionalConfigurations',
  EnableDataOutputsDimensionOrdering = 'enableDataOutputsDimensionOrdering',
  EnableNewDataSourcesUI = 'enableNewDataSourcesUI',
  EnableNewDataSourceMapping = 'enableNewDataSourceMapping',

  //Creative Node Settings V2
  EnableFacebookCreativeNodeV2 = 'enableFacebookCreativeNodeV2',
  EnableAudioVastVersions = 'useNewVastVersionColumns',
  EnableNewDspEditor = 'enableNewDspEditor',
  EnableNativeAdsCreativeFormatSelection = 'enableCreativeFormatSelection',
  EnableTeamNameSignals = 'enableTeamNameSignals',
  EnableReportFilterConditions = 'enableReportFilterConditions',
  EnableMediaDeletion = 'enableMediaDeletion',
  EnableTeatsheetVariationsCount = 'enableTeatsheetVariationsCount',
  EnableFocalRectInAdBuilder = 'enableFocalRectInAdBuilder',
  EnableSocialAdsState = 'enableSocialAdsState',
  EnableUpdatedAdsTableColumns = 'enableUpdatedAdTableColumns',
  EnableNewSetupAgentStandaloneAgent = 'enableNewSetupAgentStandaloneAgent',
  EnableUsagePage = 'enableUsagePage',
  EnableContentFeedScheduling = 'enableContentFeedScheduling',
  EnableHtmlVariationExport = 'enableHtmlVariationExport',
  EnableWebsiteEngagementLookback = 'enableWebsiteEngagementLookback',
  EnableNewPublishModalForYoutubeDV360 = 'enableNewPublishModalForYoutubeDV360',
  EnableAiContent = 'enableAiContent',
  EnableSetDuplication = 'enableSetDuplication',
  EnableSpecificItemsNewFlow = 'enableSpecificItemsNewFlow',
  SocialMockCampaignTypeEnabled = 'SocialMockCampaignTypeEnabled',
  EnableMultiFormatAdBuilder = 'enableMultiFormatAdBuilder',

  EnableClinchMasterAccountAnalytics = 'enableClinchMasterAccountAnalytics',
  EnableOpenSupportTicket = 'enableOpenSupportTicket',
}

export enum FeatureFlagStage {
  Off = 1,
  On = 20,
}

export interface RemoteFeatureFlag {
  key: FeatureFlagKey;
  stage: FeatureFlagStage;
  description: string;
  creationDate: string;
  updateDate: string;
  tags: string[];
  isUsedInBackend: boolean;
}

export interface RemoteClientFeatureFlag {
  key: FeatureFlagKey;
  clientId: number;
  clientName: string;
  value: boolean;
}

export interface RemoteUserFeatureFlag {
  key: FeatureFlagKey;
  userId: number;
  userEmail: string;
  value: boolean;
}

export type FeatureFlag = Omit<RemoteFeatureFlag, 'creationDate' | 'updateDate'> & {
  id: string;
  creationDate: DateTime;
  updateDate: DateTime;
  isOn: boolean;
  isOff: boolean;
  isUsedInFrontend: boolean;
};

export type ClientFeatureFlag = Omit<RemoteClientFeatureFlag, 'value'> & {
  id: string;
  isOn: boolean;
  isOff: boolean;
};

export type UserFeatureFlag = Omit<RemoteUserFeatureFlag, 'value'> & {
  id: string;
  isOn: boolean;
  isOff: boolean;
};

export interface EditSystemFlagForm {
  description?: string;
  tags: string[];
}

export interface NewSystemFlagForm extends EditSystemFlagForm {
  key?: string;
  stage: FeatureFlagStage;
}

export interface ChangeFlagStageForm {
  keys: FeatureFlagKey[];
  comment?: string;
  targetStage: FeatureFlagStage;
}

export type FlagWithUiTag = FeatureFlag & {uiTags: CLTagProps[]};
